import { render, staticRenderFns } from "./no_time.vue?vue&type=template&id=6899c93c&scoped=true"
import script from "./no_time.vue?vue&type=script&lang=js"
export * from "./no_time.vue?vue&type=script&lang=js"
import style0 from "./no_time.vue?vue&type=style&index=0&id=6899c93c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_85618a750ecf9a6cb90ae78d3f60d7c3/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6899c93c",
  null
  
)

export default component.exports